export const CELL_STATES = {
    UNKNOWN: 'unknown',
    FILLED: 'filled',
    CROSSED: 'crossed'
};

export const createEmptyCellStates = (rowLength) =>
    Array(rowLength).fill(CELL_STATES.UNKNOWN);

export const cycleCellState = (current) => {
    if (current === CELL_STATES.UNKNOWN) return CELL_STATES.FILLED;
    if (current === CELL_STATES.FILLED) return CELL_STATES.CROSSED;
    return CELL_STATES.UNKNOWN;
};

export const resizeCellStates = (cellStates, newLength) => {
    if (newLength === cellStates.length) return cellStates;
    if (newLength < cellStates.length) return cellStates.slice(0, newLength);
    return [...cellStates, ...createEmptyCellStates(newLength - cellStates.length)];
};
